import React from 'react';
import { useMount, useUpdateEffect } from 'react-use';

import { TableTotal, Input, Select } from '@atoms';
import { TableHeader, TableSelect, MediaTagSelect } from '@molecules';

import { SORT_OPTIONS, DEFAULT_SORT } from '@api/constants';

const SEARCH_MODE = {
  TITLE: 0,
  TAG: 1,
};

const SEARCH_OPTIONS = [
  { value: SEARCH_MODE.TITLE, label: 'By title' },
  { value: SEARCH_MODE.TAG, label: 'By tag' },
];

const Header = ({ selection, search, tag, filter, sort, info }) => {
  const [mode, setMode] = React.useState(SEARCH_MODE.TITLE);

  useMount(() => {
    if (search.defaultValue) setMode(SEARCH_MODE.TITLE);
    if (tag.defaultValue) setMode(SEARCH_MODE.TAG);
  });

  useUpdateEffect(() => {
    if (mode === SEARCH_MODE.TAG) {
      search.onSearch(undefined);
    }
    if (mode === SEARCH_MODE.TITLE) {
      tag.onChange(undefined);
    }
  }, [mode]); // eslint-disable-line

  return (
    <TableHeader>
      {selection && (
        <>
          <TableHeader.CheckBox>{selection.checkbox}</TableHeader.CheckBox>
          <TableHeader.Item>
            <TableSelect
              options={selection.options || []}
              onSelect={selection.onOptionSelect}
              placeholder={selection.placeholder || 'Options'}
              disabled={selection.disabled}
            />
          </TableHeader.Item>
        </>
      )}
      {search && (
        <>
          <TableHeader.Item>
            {mode === SEARCH_MODE.TITLE && (
              <Input.Search
                placeholder={search.placeholder || 'Search'}
                onSearch={search.onSearch}
                defaultValue={search.defaultValue}
                style={{ width: 150 }}
              />
            )}
            {mode === SEARCH_MODE.TAG && (
              <MediaTagSelect
                style={{ width: 150 }}
                dropdownMatchSelectWidth={false}
                defaultValue={tag.defaultValue}
                onChange={({ id } = {}) => tag.onChange(id)}
              />
            )}
          </TableHeader.Item>
          <TableHeader.Item>
            <Select value={mode} options={SEARCH_OPTIONS} onChange={setMode} />
          </TableHeader.Item>
        </>
      )}
      <TableHeader.Item flex="1" style={{ textAlign: 'center' }}>
        {info && <TableTotal total={info.total} singular={info.singularName} plural={info.pluralName} />}
      </TableHeader.Item>
      {filter && (
        <TableHeader.Item>
          <TableSelect
            options={filter.options}
            defaultValue={filter.defaultValue}
            onSelect={filter.onSelect}
            disabled={filter.disabled}
          />
        </TableHeader.Item>
      )}
      {sort && (
        <TableHeader.Item>
          <TableSelect
            options={sort.options || SORT_OPTIONS}
            defaultValue={sort.defaultValue || DEFAULT_SORT.key}
            onSelect={sort.onSelect}
          />
        </TableHeader.Item>
      )}
    </TableHeader>
  );
};

export default Header;
